export const SET_TOKEN_DATA = "SET_TOKEN_DATA";
export const SET_TOKEN_DATA1 = "SET_TOKEN_DATA1";
export const SET_TOKEN_DATA2 = "SET_TOKEN_DATA2";
